import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import RcPagination from 'rc-pagination';
import 'rc-pagination/dist/rc-pagination.min.css';

import { logging, logPostInfo } from '../../actions/log';
import { getOtherRankApps } from '../../actions/topn';
import ALineCard from '../../components/ALineCard/ALineCard';
import LineCard from '../../components/LineCard/LineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import styles from './RankMore.module.less';
import { getQueryString } from '../../utils/utils';
import KeepAlive, { useActivate } from 'react-activation';
import InfiniteScroll from '../../components/InfinteScroll/GridInfinteScroll';

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);
const selectOtherRankApps = createSelector(
  state => state.topn,
  topn => topn.otherRanksApps,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function RankMore() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const rankAppsData = useSelector(selectOtherRankApps);
  const searchRecommend = useSelector(selectSearchRecommend);
  const logInfoData = useSelector(selectLogInfo);

  const code = getQueryString('code');
  const sourceDetail = getQueryString('source_detail'); // 来源页面的详细位置

  // const [currentPage, setCurrentPage] = useState(1);
  // const [total, setTotal] = useState(0);
  const pageSize = 12;
  // const [isChange, setIsChange] = useState(false);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: sourceDetail ? `Rank_More||${sourceDetail}||${code}` : `Rank_More||${code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            code,
          },
        }),
      );
    };
  }, []);

  const loadMore = () => {
    if (!rankAppsData.loading && rankAppsData.pagenation.count > rankAppsData.apps.length) {
      dispatch(
        getOtherRankApps({
          skip: rankAppsData.apps.length,
          limit: 12,
          code: code || '',
          refresh: false,
        }),
      );

      // // 猜你喜欢 切换页面打桩
      // dispatch(
      //   logging({
      //     category: 'C',
      //     action: 'Paging',
      //     label: '',
      //     param2: {
      //       source: sourceDetail ? `Rank_More||${sourceDetail}||${code}` : `Rank_More||${code}`,
      //       source_p: logInfoData.source_p,
      //       source_pp: logInfoData.source_pp,
      //       // eslint-disable-next-line radix
      //       pagenum: +parseInt(rankAppsData.apps.length / 12) + 1,
      //     },
      //   }),
      // );
    }
  };

  useEffect(() => {
    dispatch(getOtherRankApps({ skip: 0, limit: pageSize, code, refresh: true }));
  }, [dispatch]);
  useActivate(() => {
    dispatch(getOtherRankApps({ skip: 0, limit: pageSize, code, refresh: true }));
  });

  useEffect(() => {
    // 排行更多页面 PV
    dispatch(
      logging({
        category: 'P',
        action: 'Rank_More',
        label: '',
        param2: {
          source: sourceDetail ? `Rank_More||${sourceDetail}||${code}` : `Rank_More||${code}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: sourceDetail ? `Rank_More||${sourceDetail}||${code}` : `Rank_More||${code}`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);
  if (
    !(
      rankAppsData &&
      rankAppsData.apps &&
      rankAppsData.apps.length > 0 &&
      rankAppsData.code === code
    )
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.recommend_guess_likes}>
      {/* <div className={styles.recommend_header}>
          <div className={styles.recommend_header_title}>{rankAppsData.desc}</div>
        </div> */}
      <div className={styles.app_cards}>
        <InfiniteScroll
          dataSource={[...rankAppsData.apps]} // 数据集
          count={rankAppsData.pagenation.count}
          minimumBatchSize={10} // 一行最多统一时间加载个数 默认10
          threshold={10} // 预加载个数
          getItemSize={(index) => {
            const soft = rankAppsData.apps[index];
            if (
              soft &&
              soft.androidType === '1' &&
              searchRecommend[soft.packageName] &&
              searchRecommend[soft.packageName].apps &&
              searchRecommend[soft.packageName].apps.length > 4
            ) {
              return 210 + (index === 0 ? 44 : 0);
            }
            if (
              soft &&
              soft.androidType !== '1' &&
              searchRecommend[soft.softID] &&
              searchRecommend[soft.softID].apps &&
              searchRecommend[soft.softID].apps.length > 4
            ) {
              return 210 + (index === 0 ? 44 : 0);
            }
            return 100 + (index === 0 ? 44 : 0);
          }} // 行高
          loadData={loadMore}
          column={1}
          template={(soft, i) => {
            return (
              <div className={styles.app}>
                {soft.androidType === '1' ? (
                  <React.Fragment>
                    <ALineCard
                      logInfo={{
                        source: sourceDetail
                          ? `Rank_More||${sourceDetail}||${code}`
                          : `Rank_More||${code}`,
                      }}
                      soft={soft}
                      softIndex={soft.packageName === rankAppsData.apps[0].packageName ? 0 : ''}
                    />
                    {searchRecommend[soft.packageName] &&
                      searchRecommend[soft.packageName].apps &&
                      searchRecommend[soft.packageName].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.packageName]}
                          logInfo={{
                            source: sourceDetail
                              ? `Rank_More||${sourceDetail}||${code}`
                              : `Rank_More||${code}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <LineCard
                      logInfo={{
                        source: sourceDetail
                          ? `Rank_More||${sourceDetail}||${code}`
                          : `Rank_More||${code}`,
                      }}
                      soft={soft}
                      softIndex={soft.softID === rankAppsData.apps[0].softID ? 0 : ''}
                    />
                    {searchRecommend[soft.softID] &&
                      searchRecommend[soft.softID].apps &&
                      searchRecommend[soft.softID].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.softID]}
                          logInfo={{
                            source: sourceDetail
                              ? `Rank_More||${sourceDetail}||${code}`
                              : `Rank_More||${code}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                )}
              </div>
            );
          }}
          tpl={() => (
            <div className={styles.recommend_header}>
              <div className={styles.recommend_header_title}>{rankAppsData.desc}</div>
            </div>
          )}
        />
      </div>
    </div>
  );
}
// });

export default () => (
  <KeepAlive name="rankmore">
    <RankMore></RankMore>
  </KeepAlive>
);
